import { IFormlyConfig, ITypeOptions } from "AngularFormly";
import { RecordRepeaterController } from "./controller";
import { RecordCopyDeleteController } from "./recordCopyDeleteController";
import { RecordEditRepeaterController } from "./editController";

export function repeaterConfig(formlyConfigProvider: IFormlyConfig) {
  const repeaterType: ITypeOptions = {
    name: "recordRepeater",
    wrapper: ["bootstrapHasError"],
    template: require("!html-loader!./index.html").default,
    controller: RecordRepeaterController,
  };
  formlyConfigProvider.setType(repeaterType);

  const editRepeaterType: ITypeOptions = {
    name: "recordEditRepeater",
    wrapper: ["bootstrapHasError"],
    template: require("!html-loader!./index.html").default,
    controller: RecordEditRepeaterController,
  };
  formlyConfigProvider.setType(editRepeaterType);

  const repeaterCopyDeleteButtonType: ITypeOptions = {
    name: "recordRepeaterCopyDelete",
    wrapper: ["bootstrapLabel", "bootstrapHasError"],
    template: require("!html-loader!./recordCopyDelete.html").default,
    controller: RecordCopyDeleteController,
  };

  formlyConfigProvider.setType(repeaterCopyDeleteButtonType);
}
repeaterConfig.$inject = ["formlyConfigProvider"];
